export const Auth0 = {
    domain: 'rocksoft-it.eu.auth0.com',
    audience: 'working-hours-registry-api',
    clientID: 'dMahMGxxmP36pm26U3qTXclCRwrCu0VX',
    responseType: 'token id_token',
    scope: 'openid email profile',
  };